import {ApiRequestParamsConfig} from '../services/api-params.service';
import {ApiRequestKey} from '../../shared/enums/api-request-key.enum';
import {BusinessParamName, TechnicalParamName} from '../../shared/models/request-offer/request-offer.enum';

export const API_REQUESTS_PARAMS_CONFIG: ApiRequestParamsConfig[] = [
    {
        requestKey: ApiRequestKey.PREPARE_AZTEC_SESSION,
        businessParams: [
            BusinessParamName.CONFIGURATION_CODE,
            BusinessParamName.SESSION_ID,
        ]
    },
    {
        requestKey: ApiRequestKey.DECODE_AZTEC,
        businessParams: [
            BusinessParamName.CONFIGURATION_CODE,
        ]
    },
    {
        requestKey: ApiRequestKey.POST_CALCULATION,
        businessParams: [
            BusinessParamName.SESSION_ID,
            BusinessParamName.SESSION_SIMPLE_ID,
            BusinessParamName.CALCULATION_ID,
            BusinessParamName.STORAGE_CALCULATION_DATA_IN_PORTAL,
            BusinessParamName.CONFIGURATION_CODE,
            BusinessParamName.SALES_CHANNEL,
            BusinessParamName.CACHE_OFFER,
            BusinessParamName.MAIL_NOTIFICATION,
            BusinessParamName.RECALCULATION_OFFER,
            BusinessParamName.CALCULATION_SIMPLE_ID,
            BusinessParamName.CALCULATION_SOURCE,
            BusinessParamName.SESSION_RECREATE_ID,
            BusinessParamName.SESSION_STAGE,
            BusinessParamName.SELECTED_USER_FILTERS,
            BusinessParamName.LOGGED_USER_ID,
            BusinessParamName.ORIGIN,
            BusinessParamName.PARTNER_EXTERNAL_ID,
            BusinessParamName.CLIENT_SOURCE,
            BusinessParamName.PARTNER_CALCULATION_ID,
            BusinessParamName.CONTEXT,
            BusinessParamName.ANALYTICS_USER_ID,
            BusinessParamName.APPLICATION_CONTEXT,
            BusinessParamName.DEVICE_SERIAL_NUMBER,
            BusinessParamName.PARTNER_SHORT_NAME,
            BusinessParamName.PORTAL_PARTNER_ID,
            BusinessParamName.PORTAL_USER_ID,
            BusinessParamName.APPLICATION_ID,
            BusinessParamName.INVALID_PARTNER_NAME,
        ],
        technicalParams: [
            TechnicalParamName.OPERATION_NAME,
            TechnicalParamName.CALLBACK_NOTIFICATION,
        ]
    },
    {
        requestKey: ApiRequestKey.PREPARE_REGISTRATION,
        businessParams: [
            BusinessParamName.SESSION_ID,
            BusinessParamName.SESSION_SIMPLE_ID,
            BusinessParamName.CALCULATION_ID,
            BusinessParamName.STORAGE_CALCULATION_DATA_IN_PORTAL,
            BusinessParamName.CONFIGURATION_CODE,
            BusinessParamName.SALES_CHANNEL,
            BusinessParamName.CACHE_OFFER,
            BusinessParamName.MAIL_NOTIFICATION,
            BusinessParamName.RECALCULATION_OFFER,
            BusinessParamName.CALCULATION_SIMPLE_ID,
            BusinessParamName.OFFER_ID,
            BusinessParamName.APPLICATION_ID,
            BusinessParamName.APPLICATION_CONTEXT,
            BusinessParamName.PARTNER_SHORT_NAME,
            BusinessParamName.PORTAL_PARTNER_ID,
            BusinessParamName.PORTAL_USER_ID,
            BusinessParamName.LOGGED_USER_ID,
            BusinessParamName.INVALID_PARTNER_NAME,
        ],
        technicalParams: [
            TechnicalParamName.OPERATION_NAME,
            TechnicalParamName.CALLBACK_NOTIFICATION,
        ]
    },
    {
        requestKey: ApiRequestKey.OFFER_MODIFICATIONS,
        businessParams: [
            BusinessParamName.SESSION_ID,
            BusinessParamName.SESSION_SIMPLE_ID,
            BusinessParamName.CALCULATION_ID,
            BusinessParamName.STORAGE_CALCULATION_DATA_IN_PORTAL,
            BusinessParamName.CONFIGURATION_CODE,
            BusinessParamName.SALES_CHANNEL,
            BusinessParamName.CACHE_OFFER,
            BusinessParamName.MAIL_NOTIFICATION,
            BusinessParamName.RECALCULATION_OFFER,
            BusinessParamName.CALCULATION_SIMPLE_ID,
            BusinessParamName.CALCULATION_SOURCE,
            BusinessParamName.OFFER_ID,
            BusinessParamName.SELECTED_USER_FILTERS,
            BusinessParamName.APPLICATION_CONTEXT,
        ],
        technicalParams: [
            TechnicalParamName.OPERATION_NAME,
            TechnicalParamName.CALLBACK_NOTIFICATION,
        ]
    },
    {
        requestKey: ApiRequestKey.POST_REGISTRATION,
        businessParams: [
            BusinessParamName.SESSION_ID,
            BusinessParamName.SESSION_SIMPLE_ID,
            BusinessParamName.CALCULATION_ID,
            BusinessParamName.CALCULATION_SIMPLE_ID,
            BusinessParamName.INSURANCE_COMPANY_CODE,
            BusinessParamName.ORDER_ID,
            BusinessParamName.CONFIGURATION_CODE,
            BusinessParamName.SALES_CHANNEL,
            BusinessParamName.MAIL_NOTIFICATION,
            BusinessParamName.RECALCULATION_OFFER,
            BusinessParamName.APPLICATION_ID,
            BusinessParamName.PARTNER_SHORT_NAME,
            BusinessParamName.PORTAL_PARTNER_ID,
            BusinessParamName.PORTAL_USER_ID,
            BusinessParamName.CLIENT_SOURCE,
            BusinessParamName.LOGGED_USER_ID,
            BusinessParamName.ORIGIN,
            BusinessParamName.PARTNER_EXTERNAL_ID,
            BusinessParamName.ANALYTICS_USER_ID,
            BusinessParamName.ANALYTICS_CLIENT_ID,
            BusinessParamName.ANALYTICS_SESSION_ID,
            BusinessParamName.APPLICATION_CONTEXT,
            BusinessParamName.DEVICE_SERIAL_NUMBER,
            BusinessParamName.REFERENCE_OFFER_ID,
            BusinessParamName.QUOTATION_ID,
            BusinessParamName.OFFER_PACKAGE_NAME,
            BusinessParamName.OFFER_PRIMARY_COVERAGES,
            BusinessParamName.INVALID_PARTNER_NAME,
        ],
        technicalParams: [
            TechnicalParamName.OPERATION_NAME,
            TechnicalParamName.CALLBACK_NOTIFICATION,
        ]
    },
    {
        requestKey: ApiRequestKey.NOTIFICATION,
        businessParams: [
            BusinessParamName.SESSION_ID,
            BusinessParamName.SESSION_SIMPLE_ID,
            BusinessParamName.SALES_CHANNEL,
            BusinessParamName.ORDER_ID,
            BusinessParamName.REFERENCE_OFFER_ID,
            BusinessParamName.APPLICATION_ID,
            BusinessParamName.APPLICATION_CONTEXT,
        ],
        technicalParams: [
            TechnicalParamName.DESTINATION,
        ]
    },
    {
        requestKey: ApiRequestKey.DRAFT_OFFER,
        businessParams: [
            BusinessParamName.SESSION_ID,
        ]
    }
];
